/** @format */
import React, { useState } from "react";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import "bootstrap/dist/css/bootstrap.min.css";
import "./DocStat.css";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const DocStat = ({ lots, onFilterClick }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const toggleCollapse = () => setIsCollapsed(!isCollapsed);
  const { t } = useTranslation();

  // Stats globales
  const globalStats = lots.reduce(
    (acc, lot) => {
      acc.totalDocuments += 1; // chaque lot = 1 document
      if (lot.Status === "completed") acc.realisesDocuments = (acc.realisesDocuments || 0) + 1;
      return acc;
    },
    { totalDocuments: 0, realisesDocuments: 0 }
  );

  // Comptage par status
  const statusCounts = lots.reduce((acc, lot) => {
    const status = lot.Status || "unknown";
    acc[status] = (acc[status] || 0) + 1;
    return acc;
  }, {});

  // Cartes fixes
  const fixedCards = [
    {
      label: `${t("Total")} ${t("Documents")}`,
      value: globalStats.totalDocuments,
      border: "#185d8b",
      filterKey: null,
    }
  ];

  // Cartes dynamiques par status avec pourcentage
  const statusCards = Object.entries(statusCounts).flatMap(([status, count]) => [
    {
      label: t(status),
      value: `${count} (${((count / globalStats.totalDocuments) * 100).toFixed(1) + "%"})` ,
      border: "#"+(((1<<24)*Math.random())|0).toString(16),
      filterKey: status,
    },
    
  ]);

  //  Chart horizontal
  const chartData = {
    labels: Object.keys(statusCounts),
    datasets: [
      {
        label: t("Documents"),
        data: Object.values(statusCounts),
        backgroundColor: [
          "rgba(255, 99, 132, 0.8)",
          "rgba(54, 162, 235, 0.8)",
          "rgba(75, 192, 192, 0.8)",
          "rgba(255, 206, 86, 0.8)",
          "rgba(153, 102, 255, 0.8)",
          "rgba(255, 159, 64, 0.8)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { position: "top" }, tooltip: { enabled: true } },
    scales: { x: { beginAtZero: true, ticks: { stepSize: 1 } } },
  };

  return (
    <div className="size-stats">
      <div className="d-flex position_stats" onClick={toggleCollapse}>
        <div className="position_stats_arrow">
          <FontAwesomeIcon icon={isCollapsed ? faChevronDown : faChevronUp} />
        </div>
        <p style={{ fontWeight: "bold", fontSize: "18px", paddingTop: "10px", margin: 0 }}>
          {t("Statistics")}
        </p>
      </div>

      {!isCollapsed && (
        <div className="stats-content-wrapper">
          {/* Chart */}
          <div className="chart-card">
            <Bar data={chartData} options={options} />
          </div>

          {/* Cartes */}
          <div className="cards-wrapper">
            {[...fixedCards, ...statusCards].map((card, i) => (
              <div
                key={i}
                className="stat-item-card"
                onClick={() => onFilterClick?.(card.filterKey ?? "")}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";
                  e.currentTarget.style.border = `1px solid ${card.border}`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.08)";
                  e.currentTarget.style.border = "1px solid #e0e0e0";
                }}
              >
                <p>{card.label}</p>
                <h3>{card.value}</h3>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DocStat;
